import { useEffect, useRef } from "react";
import "@/App.css";
import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import Dashboard from "@/pages/Dashboard";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Scope } from "@/components/site/Scope";
import { Experience } from "@/components/site/Experience";
import { Credentials } from "@/components/site/Credentials";
import { Practical } from "@/components/site/Practical";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function Site() {
  const logged = useRef(false);
  useEffect(() => {
    if (logged.current) return;
    logged.current = true;
    axios.post(`${API}/visits`, { path: "/", referrer: document.referrer || null, host: window.location.hostname }).catch(() => {});
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
    window.__lenis = lenis;
    return () => {
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App min-h-screen bg-[#F6F5F2]">
      <Nav />
      <Hero />
      <Scope />
      <Experience />
      <Credentials />
      <Practical />
      <Contact />
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Site />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
